import data from "../../../../../packages/react/src/KeybindingHint/KeybindingHint.docs.json";
import { ActionList, Button, Text, Box } from '@primer/react';
import { KeybindingHint } from '@primer/react/drafts';
import { TrashIcon } from '@primer/octicons-react';
import * as React from 'react';
export default {
  data,
  ActionList,
  Button,
  Text,
  Box,
  KeybindingHint,
  TrashIcon,
  React
};